export const styles = {
  createNewStory: {},
};
